export default __webpack_public_path__ + "static/media/activateLogoBlack.061b8f2e.png";